import React from "react";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import uploadDatasetIcon from "images/tileIcons/uploadDataset.svg";

import TraySolutionVendorImage from "components/Tiles/TraySolutionVendorImage";

import { InfoItem, InfoIcon, DeleteButton } from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";

import styles from "./style.module.css";

const dataStyles = getStyles("dataset");

export default class RecipeTile extends React.PureComponent {
  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete } = this.props;

    if (handleDelete) {
      return handleDelete();
    } else return;
  }

  render() {
    const { recipe, isCreate, isUpdating, onClick, handleDelete, handleConfigure } = this.props;

    if (isCreate) {
      return <UploadDatasetTile onClick={onClick} />;
    }

    if (!recipe) {
      return <React.Fragment></React.Fragment>;
    }

    return (
      <div className={styles.tileWrapper}>
        <div
          className={onClick ? styles.tile : styles.tileNoHover}
          onClick={() => {
            if (onClick) {
              return onClick(recipe.id);
            }
          }}
        >
          <div className={styles.tileActions}>
            {handleDelete ? <DeleteButton type={"recipe"} clickHandler={this.handleDelete.bind(this)} /> : ""}
          </div>
          <div style={{ height: "130px" }} className={styles.tileHeader + " " + styles.recipeBackground}>
            <h1 style={{ marginBottom: "0px" }} title={recipe.name} className={styles.recipeHeaderText}>
              {recipe.name}
            </h1>
            <div className={styles.heroIcons}>
              {isUpdating === true ? (
                <LoadingIndicator />
              ) : (
                recipe.traySolution && (
                  <TraySolutionVendorImage style={{ height: "110px" }} vendor={recipe.traySolution.vendor} />
                )
              )}
            </div>
          </div>
          <div className={styles.tileBody}>
            {recipe.createdBy ? (
              <InfoItem
                icon={<InfoIcon type="user" />}
                iconStyle={{ color: styles.aibleColor }}
                text={recipe.createdBy.fullname}
                hideMobile
              />
            ) : (
              ""
            )}
            {recipe.createdDate ? (
              <InfoItem
                icon={<InfoIcon type="calendar" />}
                text={moment.utc(recipe.createdDate).local().fromNow()}
                title={moment.utc(recipe.createdDate).local().format("MMMM Do YYYY, h:mm:ss a")}
              />
            ) : (
              ""
            )}
            <div
              onClick={(e) => {
                e.stopPropagation();

                if (!isUpdating) {
                  handleConfigure();
                }
              }}
            >
              <InfoItem
                icon={<InfoIcon type="link" />}
                iconClass={styles.warningColor}
                text={"Configure Recipe"}
                isLink={!isUpdating}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class UploadDatasetTile extends React.PureComponent {
  render() {
    const { onClick, loading, isTableau, isTray } = this.props;
    const image = uploadDatasetIcon;
    const title = "Create Recipe";
    const text = title;
    return (
      <div className={styles.tileWrapper}>
        <div className={onClick ? styles.tile : styles.tileNoHover} onClick={onClick ? () => onClick() : () => {}}>
          <div className={styles.createTileImageWrapper}>
            <div className={styles.createTileIcon}>
              {loading ? (
                <LoadingIndicator color={"var(--dataset-text)"} style={{ margin: "0px" }} />
              ) : (
                <img src={image} alt={text} />
              )}
            </div>
          </div>
          <div className={styles.tileBody}>
            <div className={styles.createTileHeader + " " + dataStyles.text} title={title}>
              {text}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
